export default __webpack_public_path__ + "static/media/product_healthCheck_En.ed89f01c.webp";